//Componentes generales
import React, { useState, useEffect } from "react";
import AutocompleteV2 from "../AutoCompleteV2/AutoCompleteV2";
import SelectList from "../SelectList/SelectList";

// Estilos
import "./NewProductItm.css";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

/*
    Componente encargado de toda la logica del ingreso de un nuevo item en carga de requerimiento.
        Donde data es el item en el cual esta posicionado.
              index es la posición del item.
              productList es la lista de productos disponibles.
              agregaItem es la función que agrega el nuevo item.
              modificaItm es la función que modifica el item.
              borraItem es la función que borra el item.
*/
function NewProductItm({
  data,
  index,
  productsList,
  agregaItem,
  modificaItm,
  borraItem,
  tiposCosto,
  centrosCosto,
}) {
  //state de item.
  const [selected, setSelected] = useState(data);

  /* 
        Manejador encargado de la logica del autocompletado ante una modificación.
            Donde value es el valor ingresado por el usuario.
    */
  const handlerChangeAutoComplete = (value) => {
    const indice = index;
    const productoSeleccionado = productsList.find(
      (p) =>
        `${p.tipPro}${p.artCod}`.replace(/\s+/g, "") ===
        value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (productoSeleccionado !== undefined) {
      const s = {
        ...data,
        tipPro: productoSeleccionado.tipPro,
        artCod: productoSeleccionado.artCod,
        codRed: productoSeleccionado.codRed,
        descrp: productoSeleccionado.descrp,
        price: productoSeleccionado.price,
      };

      if (data.artCod !== "") modificaItm(s, indice);
      else agregaItem(s);
      setSelected(s);
    }
    if (productoSeleccionado == undefined && value == "") {
      borraItem(data, indice);
      setSelected(data);
    }
  };

  /* 
        Manejador encargado de la modificación de la cantidad del item.
            Donde cantid es el valor ingresado por el usuario.
    */
  const handleChangeQuantity = (cantid) => {
    const indice = index;
    if (cantid > 0) {
      const s = { ...selected, quantity: cantid };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

  /* 
        Manejador encargado de la modificación del texto del item.
            Donde texto es el valor ingresado por el usuario.
    */
  const handleChangeTextAdic = (texto) => {
    const indice = index;
    const s = { ...selected, textAdic: texto };
    setSelected(s);
    modificaItm(s, indice);
  };

  const handleChangeTipoCosto = async (value) => {
    const tipoCostoSeleccionado = tiposCosto.find(
      (tC) =>
        `${tC.subCue}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (tipoCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        tipoCosto: {
          abmCodDim: tipoCostoSeleccionado.codDim,
          abmCodDimDescrp: tipoCostoSeleccionado.codDimDescrp,
          abmSubCue: tipoCostoSeleccionado.subCue,
          abmSubCueDescrp: tipoCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

  const handleChangeCentroCosto = async (value) => {
    const centroCostoSeleccionado = centrosCosto.find(
      (cC) =>
        `${cC.subCue}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (centroCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        centroCosto: {
          abmCodDim: centroCostoSeleccionado.codDim,
          abmCodDimDescrp: centroCostoSeleccionado.codDimDescrp,
          abmSubCue: centroCostoSeleccionado.subCue,
          abmSubCueDescrp: centroCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

  return (
    <div className="container-row-form-item">
      <div>
        <FontAwesomeIcon
          icon={faBackspace}
          color="red"
          style={{
            width: "35px",
            height: "35px",
            marginTop: "5px",
            cursor: "pointer",
          }}
          onClick={borraItem}
        />
      </div>

      <div className="input-autocomplete-form-item" style={{ width: "33%" }}>
        <AutocompleteV2
          placeholder={"Ingrese un producto"}
          height={"40px"}
          value={
            selected.tipPro !== ""
              ? `${selected.tipPro}${selected.artCod} ~ ${selected.descrp}`
              : ""
          }
          setValue={handlerChangeAutoComplete}
          dataSuggestions={productsList.map((p) => {
            return {
              code: `${p.tipPro}${p.artCod}`,
              descrp: `${p.descrp} (${p.codRed})`,
            };
          })}
        />
      </div>

      <input
        value={selected.quantity === 0 ? 1 : selected.quantity}
        type="number"
        placeholder="Cantidad"
        onChange={(datat) => handleChangeQuantity(datat.target.value)}
        style={{
          height: "40px",
          width: "50px",
          textAlign: "left",
          fontSize: "1rem",
          borderRadius: 5,
          border: "none",
          boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ",
          textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
        }}
      />

      <input
        value={selected.textAdic}
        placeholder="Ingrese descripción adicional"
        onChange={(datat) => handleChangeTextAdic(datat.target.value)}
        style={{
          width: "23%",
          fontSize: "1rem",
          height: "40px",
          borderRadius: 5,
          border: "none",
          boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ",
          textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
        }}
      />
      {tiposCosto && (
        <div className="selectSubcuenta" style={{ width: "22%" }}>
          <SelectList
            colorInputText={selected.tipoCosto?.abmSubCue ? "black" : "#7c7b7b"}
            textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
            backgroundColor={"white"}
            menuPlacement={"bottom"}
            height={"40px"}
            border={true}
            options={tiposCosto.map((cC) => {
              return {
                value: `${cC.subCue}`,
                label: `${cC.subCue} - ${cC.subCueDescrp}`,
              };
            })}
            handleChange={handleChangeTipoCosto}
            property={"Tipo de Costo"}
            valueAux={{
              label: selected.tipoCosto?.abmSubCue
                ? `${selected.tipoCosto?.abmSubCue} - ${selected.tipoCosto?.abmSubCueDescrp}`
                : "Seleccione tipo de costo...",
              value: selected.tipoCosto?.abmSubCue || "",
            }}
            emptyInputs={[]}
            styles={{
              additionalStyleDivSelectList: {
                alignItems: "left",
              },
              fontStyleTitle: {
                fontSize: "1rem",
                color: "#7c7b7b",
                marginLeft: "9px",
              },
            }}
            fontBold={true}
          />
        </div>
      )}
      {centrosCosto && (
        <div className="selectSubcuenta" style={{ width: "22%" }}>
          <SelectList
            colorInputText={
              selected.centroCosto?.abmSubCue ? "black" : "#7c7b7b"
            }
            textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
            backgroundColor={"white"}
            menuPlacement={"bottom"}
            height={"40px"}
            border={true}
            options={centrosCosto.map((cC) => {
              return {
                value: `${cC.subCue}`,
                label: `${cC.subCue} - ${cC.subCueDescrp}`,
              };
            })}
            handleChange={handleChangeCentroCosto}
            property={"Centro de Costo"}
            valueAux={{
              label: selected.centroCosto?.abmSubCue
                ? `${selected.centroCosto?.abmSubCue} - ${selected.centroCosto?.abmSubCueDescrp}`
                : "Seleccione centro de costo...",
              value: selected.centroCosto?.abmSubCue || "",
            }}
            emptyInputs={[]}
            styles={{
              additionalStyleDivSelectList: {
                alignItems: "left",
              },
              fontStyleTitle: {
                fontSize: "1rem",
                color: "#7c7b7b",
                marginLeft: "9px",
              },
            }}
            fontBold={true}
          />
        </div>
      )}
    </div>
  );
}

export default NewProductItm;